<template>
  <div class="journals-routes full-routes" v-if="list.length > 0">
    <bread-icon class="icon"></bread-icon>
    <router-link class="link-name"
                 :to="setLink(list[0])"
                 v-if="list.length < 2">
      <span v-if="list[0] && list[0].name">
        {{list[0].name}}
      </span>
    </router-link>
    <div v-if="list.length > 1"
         @click="show = true"
         @mouseleave="show = false"
         class="link-list">
      <dots-icon class="dots"></dots-icon>
      <transition name="fade">
        <ul class="links-list_inner" v-show="show">
          <router-link tag="li"
                       v-for="(link, index) in list"
                       :key="'link' + link.id"
                       :to="setLink(link)"
                       v-if="list.length -1 !== index"
                       class="link-name_inner">
            <span v-if="link && link.name">
              <trim-item :string="link.name" :width="50"></trim-item>
            </span>
          </router-link>
        </ul>
      </transition>
    </div>
    <bread-icon v-if="list.length > 1"
                class="icon"></bread-icon>
    <trim-item v-if="list.length > 1"
               :string="list[list.length - 1].name"
               :offset="60"
               :width="50">
    </trim-item>
  </div>
</template>

<script>
  import {breadcrumbsMixin} from "../../../mixins/sidebar/breadcrumbsMixin";
  import {mapGetters, mapState} from 'vuex'
  import trimItem from '../../trimITem'

  export default {
    name: 'journalRoutes',
    mixins: [breadcrumbsMixin],
    components: {trimItem},
    computed: {
      ...mapState({
        activeSection: state => state.things.activeSectionThings,
        thing: state => state.things.device,
        ownedThings: state => state.things.ownedThing,
        allThingsFromGetOwned: state => state.things.allThingsFromGetOwned,
        assignedThings: state => state.things.assignedThings,
      }),
      ...mapGetters({
        tree: 'things/tree'
      }),
      thingsList() {
        return this.ownedThings
      },
      list() {
        // let itemTree;
        let breadscrumbs = [];

        let setPrevDevice = (parentId) => {
          this.allThingsFromGetOwned.forEach((item) => {
            if (item.id === Number(parentId)) {
              breadscrumbs.unshift(item)
              if (item.parent_device_id) {
                setPrevDevice(item.parent_device_id)
              }
            }
          })
        }

        if (this.allThingsFromGetOwned) {
          this.allThingsFromGetOwned.forEach((item) => {
            if (item.id === Number(this.routeId)) {
              breadscrumbs.push(item)
              if (item.parent_device_id) {
                setPrevDevice(item.parent_device_id)
              }
            }
          })
        }
        return breadscrumbs
      }
    },
    methods: {
      setLink(item) {
        if (item) {
          let groups = item.groups;
          if (groups != 'none') {
            return `/journals/multithing/${item.id}`
          } else {
            return `/journals/multithing/${item.id}`
          }
        };
        return '/things'
      }
    }
  }
</script>

<!--//стили не scoped-->
<style lang="scss">
.journals-routes {
  flex-wrap: nowrap;
  .trim-text {
    overflow: visible !important;
  }
  svg {
    min-width: 20px;
  }
}

  .journals-routes {
    max-width: 60%;
  }

  .link-name {
    white-space: nowrap;
  }
</style>
